module.exports = __webpack_public_path__ + "img/gray-walkman.70992d8c.png";